import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Iterable } from 'immutable';
import Button from '@Components/Button';
import Auth from '@Services/Auth';
import { getValueByNs } from '@Hooks/LibraryInitialization/MoreUnderscore';

const componentClassName = 'notification';

// TODO: replace with Leyden Banner
export default function NotificationBar(props) {
  const { content, type, children, className, icon, id, parentType } = props;

  const [isClosed, setClosed] = useState(getValueByNs(Auth.getUser(), `flags.${componentClassName}-${id}`, false));

  function hideNotification() {
    const flags = Auth.getUser()?.flags || {};
    const barId = `${componentClassName}-${id}`;
    setClosed((flags[barId] = true));
    Auth.updateUser({ flags });

    const sheet = document.createElement('style');
    sheet.innerHTML = `.${barId} {display: none}`;
    sheet.id = barId;
    document.body.appendChild(sheet);
  }

  return isClosed ? null : (
    <NotificationBarWrapper parentType={parentType} id={id}>
      <section className={classnames(className, `${componentClassName}--${type}`, 'u-els-margin-bottom-1x')}>
        <Button
          // eslint-disable-next-line react/jsx-no-bind
          onClick={hideNotification}
          buttonConfig={{
            type: 'link',
            size: 'xs',
            ariaLabel: 'Hide notification bar',
            iconOnly: true,
            className: 'els-btn-modal-close',
            e2eName: 'notification-close',
          }}
          iconConfig={{ name: 'delete' }}
        />
        <div className={classnames(`${componentClassName}--icon`)}>
          {icon ? (
            <svg className="svg-icon">
              <use xlinkHref={`#icon-${icon}`} />
            </svg>
          ) : (
            '!'
          )}
        </div>
        <div className={classnames(`${componentClassName}--content`)}>
          {content}
          {children}
        </div>
      </section>
    </NotificationBarWrapper>
  );
}

function NotificationBarWrapper(props) {
  const { children, parentType, id } = props;
  switch (parentType) {
    case 'table':
      return (
        <tr className={`slim ${componentClassName}-${id}`}>
          <th colSpan="100">{children}</th>
        </tr>
      );
    default:
      return <div className={`${componentClassName}-${id}`}>{children}</div>;
  }
}

NotificationBar.propTypes = {
  content: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.oneOf(['warning', 'info', 'error']),
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array, PropTypes.instanceOf(Iterable)]),
  icon: PropTypes.string,
  id: PropTypes.string,
  parentType: PropTypes.string,
};

NotificationBarWrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array, PropTypes.instanceOf(Iterable)]),
  id: PropTypes.string,
  parentType: PropTypes.string,
};
